<template>
	<div class="_pagina_statistiche_personali">
		<div class="d-flex flex-column " style="margin: 0 30px 20px;">
			<div data-tour-step-statistiche="1"
					 class="_semi_bold mb-2"
					 style="color:#434343; font-size:25px; flex: 0 1 auto;"
			>
				Statistiche {{idCliccatore != null && usernameCliccatore != null ? usernameCliccatore : 'Personali'}}
			</div>
			<div data-tour-step-statistiche="2" class="d-flex align-center" style="flex: 1 1 auto">
				<div class="_semi_bold" style="font-size:18px; margin-right:25px;">
					Seleziona il periodo
					<v-icon :style="`margin-left:5px; font-size:20px; color:${scdColor}`">
						event
					</v-icon>
				</div>
				<div style="margin-right:25px;">
					<v-menu
						ref="dal"
						v-model="menuDal"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="90px"
					>
						<template v-slot:activator="{ on }">
							<div class="d-flex align-center">
								<div style="font-size:18px;">Dal</div>
								<v-text-field class="input_seleziona_periodo" style="width:120px; padding-left:7px;" :color="scdColor"
															clearable @click:clear="dateDal = null" readonly :value="dateITFormat(dateDal)"
															v-on="on"></v-text-field>
							</div>
						</template>
						<v-date-picker :color="scdColor" locale="it" v-model="dateDal" no-title
													 @input="menuDal = false"></v-date-picker>
					</v-menu>
				</div>
				<div style="margin-right:25px;">
					<v-menu
						ref="al"
						v-model="menuAl"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="90px"
					>
						<template v-slot:activator="{ on }">
							<div class="d-flex align-center">
								<div style="font-size:18px;">Al</div>
								<v-text-field class="input_seleziona_periodo" style="width:120px; padding-left:7px;" :color="scdColor"
															readonly clearable @click:clear="dateAl = null" :value="dateITFormat(dateAl)"
															v-on="on"></v-text-field>
							</div>
						</template>
						<v-date-picker :color="scdColor" locale="it" v-model="dateAl" no-title
													 @input="menuAl = false"></v-date-picker>
					</v-menu>
				</div>
			</div>
			<div class="d-flex align-center" style="width:715px;">
				<div class="_semi_bold" style="font-size:18px; margin-right:25px;">Scegli il bando</div>
				<v-select
					style="margin-right:25px;"
					item-text="nome"
					item-value="id"
					:items="bandi"
					v-model="bandoId"
					placeholder="Seleziona"
					:loading="isLoadingBandi"
				></v-select>
				<v-btn depressed :color="scdColor" class="_semi_bold"
							 style="color:white; text-transform:none; letter-spacing:1px; padding:0 30px;" rounded
							 @click="getStatsCliccatore()">Conferma
				</v-btn>
			</div>
		</div>

		<v-row v-if="isLoadingStats || isLoadingBandi" justify="center">
			<v-progress-circular class="mt-12" :color="scdColor" size="32" width="3" indeterminate></v-progress-circular>
		</v-row>

		<div v-else>
			<div style="background-color:white;">
				<v-row style="padding: 20px 50px;">
					<v-col style="margin-top:15px;" sm="4" data-tour-step-statistiche="3">
						<v-row style="color:#434343" class="_semi_bold">Tempo medio:<span
							:style="`color:${scdColor}; margin-left:5px;`">{{!isNaN(tempoMedioComplessivo) ? tempoMedioComplessivo + "s" : "-"}}</span>
						</v-row>
						<v-row style="color:#434343" class="mb-3 _semi_bold">Simulazioni totali:<span
							:style="`color:${scdColor}; margin-left:5px;`">{{numSimulazioniTotali}}</span></v-row>
						<chart-pie-component :height="220" :chartData="pieChart"/>
					</v-col>
					<v-col sm="8">
						<chart-line-component data-tour-step-statistiche="4" :chartData="dataLineChart" :height="300"
																	:options="options"/>
					</v-col>
				</v-row>
			</div>

			<v-row class="mt-2">
				<v-col cols="6" md="4" class="mx-6">
					<v-text-field autocomplete="search-cliccatore" label="Cerca data simulazione" v-model="search"
												prepend-icon="search"/>
				</v-col>
			</v-row>
			<v-data-table
				class="mt-0 mx-2 mb-2 statistiche-data-table"
				data-tour-step-statistiche="5"
				:headers="headers"
				:items="tableStatsCliccatore"
				:no-data-text="isLoadingStats ? 'In caricamento..' : 'Ancora nessuna simulazione eseguita'"
				:footer-props="{'items-per-page-options':[5, 15, 30, 100], 'items-per-page-text': 'Visualizza per pagina'}"
				single-expand
				:expanded.sync="expandedSim"
				item-key="data_ora"
				:search="search"
				:custom-filter="(value, search, item) => customFilter(item, search)"
			>
				<template slot="item" slot-scope="props">
					<tr v-if="props.item.tempo == null" class="_table_row">
						<td>{{computedDateTime(props.item.data_ora)}}</td>
						<td colspan="3" style="text-align: center;">Abbandonata</td>
						<td>
							<v-btn
								style="text-transform:none; color:white; letter-spacing:0.5px; padding:0 30px; border: 1px solid white;"
								:color="scdColor" small rounded depressed @click="espandiNascondiSimulazione(props.item)">
								{{expandedSim == props.item.data_ora ? "Chiudi dettagli simulazione" : "Dettagli simulazione"}}
							</v-btn>
						</td>
					</tr>
					<tr v-else class="_table_row">
						<td>{{computedDateTime(props.item.data_ora)}}</td>
						<td style="color:white;"
								:class="`_semi_bold ${props.item.tempo <= tempoDaBattere && props.item.tempo != null ? ' bg_green' : (props.item.tempo > tempoDaBattere && props.item.tempo != null ? ' bg_red' : '')}`">
							{{props.item.tempo ? props.item.tempo + " s" : ""}}
						</td>
						<td>{{props.item.posClassifica + "° di " + props.item.partecipantiTot + " partecipanti"}}</td>
						<td>{{props.item.mediaPartecipanti + " s"}}</td>
						<td>
							<v-btn
								:style="`text-transform:none; color:white; letter-spacing:0.5px; padding:0 30px; border: 1px solid white;`"
								:color="scdColor" small rounded depressed @click="espandiNascondiSimulazione(props.item)">
								{{
									expandedSim.length > 0 && expandedSim[0].data_ora.localeCompare(props.item.data_ora) == 0 ? "Chiudi dettagli simulazione" : "Dettagli simulazione"
								}}
							</v-btn>
						</td>
					</tr>
				</template>
				<template v-slot:expanded-item="{ headers, item }">
					<tr class="_table_row _dettagli_simulazione" v-for="(sim, index) in item.simulazione" :key="index">
						<!-- <td :colspan="1"><b>Tipo:</b> {{ sim.tipo == 'select' ? 'Menù a tendina' : (item.tipo == 'radio' ? 'Risposta multipla' : 'Testo da scrivere') }}</td> -->
						<td :colspan="1"><b>Tipo:</b> {{sim.tipo}}</td>
						<td :colspan="2"><b>Domanda:</b> {{sim.domanda}}</td>
						<td :colspan="sim.risposte != null ? 1 : 2"><b>Risposta Corretta:</b> {{sim.risposte[0]}}</td>
						<td :colspan="1" v-if="sim.risposte != null"><b>Risposte Possibili:</b>
							{{sim.risposte != null ? sim.risposte.toString().split(',').join(' - ') : ''}}
						</td>
						<!-- <td :colspan="1" v-if="sim.risposte != null"><b>Risposte Possibili:</b> {{ sim.risposte != null ? item.risposte.split('|').join(' - ') : '' }}</td> -->
					</tr>
				</template>
				<template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
					{{pageStart}} - {{pageStop}} di {{itemsLength}}
				</template>
			</v-data-table>
		</div>
	</div>
</template>


<script>
import mixin from '../../mixins';

export default {
	props: ['idCliccatore', 'hideGuide'],
	data() {
		return {
			menuDal: null,
			dateDal: moment().subtract(6, 'days').format('YYYY-MM-DD'),
			menuAl: null,
			dateAl: moment().format('YYYY-MM-DD'),

			isLoadingBandi: false,
			bandi: [],
			bandoId: null,

			expandedSim: [], // Array con un solo elemento (oggetto)

			search: null,

			isLoadingStats: false,

			pieChart: [],

			headers: [
				{text: 'Simulazione', value: 'data_ora'},
				{text: 'Il tuo tempo', value: 'tempo', searchable: false},
				{text: 'Classifica', value: 'posClassifica', searchable: false},
				{text: 'Tempo medio partecipanti', value: 'mediaPartecipanti', searchable: false},
				{text: 'Azioni', value: 'action', sortable: false, searchable: false},
			],

			dataLineChart: null, // Per il grafico
			options: {},

			tableStatsCliccatore: [], // Per la tabella

			usernameCliccatore: null,
			tempoDaBattere: null,
			tempoMedioComplessivo: null,
			numSimulazioniTotali: null,
			numSimulazioniVinteComplessive: null,
			numSimulazioniAbbandonateComplessive: null
		};
	},
	async created() {
		await this.getBandi()
		this.getStatsCliccatore();

		// await axios.get('/test-query')
	},
	methods: {
		getBandi() {
			this.isLoadingBandi = true;
			// this.isLoadingStats = true;
			return axios
				.get('/getBandi')
				.then(response => {
					this.bandoId = response.data.idBandoSelezionato;
					this.bandi = response.data.bandi;
				})
				.finally(() => {
					this.isLoadingBandi = false;
				})

		},
		getStatsCliccatore: function () {
			if (this.isLoadingStats) return;

			this.isLoadingStats = true;

			this.tableStatsCliccatore.splice(0, this.tableStatsCliccatore.length);

			let q = (this.idCliccatore ? "/statistiche/cliccatori/" + this.idCliccatore : "/statistiche/cliccatori");

			axios
				.get(q, {
					params: {
						data_dal: this.dateDal,
						data_al: this.dateAl,
						bando_id: this.bandoId
					}
				})
				.then(response => {
					if (response.data.hasError) {
						this.alertType = "error";
						this.message = response.data.messages[0];
						console.log('errore');
					} else {
						this.usernameCliccatore = response.data.username;
						this.tempoDaBattere = parseFloat(response.data.tempoDaBattere);

						this.numSimulazioniTotali = parseInt(response.data.numSimulazioniTotali);
						this.tempoMedioComplessivo = parseFloat(response.data.tempoMedioComplessivo);

						this.numSimulazioniVinteComplessive = parseInt(response.data.numSimulazioniVinteComplessive);
						if (isNaN(this.numSimulazioniVinteComplessive)) this.numSimulazioniVinteComplessive = 0;

						this.numSimulazioniAbbandonateComplessive = parseInt(response.data.numSimulazioniAbbandonateComplessive);
						if (isNaN(this.numSimulazioniAbbandonateComplessive)) this.numSimulazioniAbbandonateComplessive = 0;

						this.pieChart = [
							this.numSimulazioniVinteComplessive,
							this.numSimulazioniTotali - this.numSimulazioniVinteComplessive - this.numSimulazioniAbbandonateComplessive,
							this.numSimulazioniAbbandonateComplessive
						];

						this.tableStatsCliccatore = response.data.stats_tabella;

						// Dati per il grafico:
						let mieiTempi = [];
						let mieiTempiMedi = [];
						let squadraTempiMedi = [];

						let tempoDaBattere = []; // Serve a generare la linea

						let self = this;

						let counter = [];

						response.data.stats_cliccatore_per_grafico.forEach(function (riga, index) {
							mieiTempi.push(parseFloat(riga.tempo));
							mieiTempiMedi.push(parseFloat(riga.media));
							// squadraTempiMedi.push(parseFloat(riga.mediaSquadra));

							// counter.push((index+1)+"°"); => Serviva per l'etichetta
							tempoDaBattere.push(self.tempoDaBattere);

							// counter.push(""); // Senza di questo non funziona!
						})

						for (let i = 0; i < 60; i++) {
							counter.push(""); // Senza di questo non funziona!
						}
						
						squadraTempiMedi = response.data.tempi_medi_squadra

						this.dataLineChart = {
							labels: counter,
							datasets: [
								{
									label: 'Tempo da battere',
									backgroundColor: 'rgba(5, 141, 199, .1)',
									pointBackgroundColor: '#058dc7',
									pointRadius: 0,
									borderWidth: 1,
									// pointBorderColor: '#00ff00',
									borderColor: '#058dc7',
									data: tempoDaBattere
								},
								{
									label: 'I miei tempi',
									backgroundColor: '#0000ff00', // trasparente
									pointBackgroundColor: '#e69024',
									pointRadius: 1.3,
									borderWidth: 1,
									borderColor: '#e69024',
									// pointBorderColor: '#0000ff', // Bordino del pallino
									data: mieiTempi
								},
								{
									label: 'La mia media',
									backgroundColor: '#0000ff00', // trasparente
									pointBackgroundColor: '#e53926',
									pointRadius: 1.3,
									borderWidth: 1,
									borderColor: '#e53926',
									// pointBorderColor: '#0000ff', // Bordino del pallino
									data: mieiTempiMedi
								},
								{
									label: 'Media della Squadra (Solo Cliccatori con almeno 60 simulazioni svolte)',
									backgroundColor: '#f8797900', // trasparente
									pointBackgroundColor: '#538d1f', // trasparente
									pointRadius: 1.3,
									borderWidth: 1,
									borderColor: '#538d1f',
									data: squadraTempiMedi
								},
							]
						};

						this.options = {
							title: {
								display: false
							},
							scales: {
								yAxes: [{
									scaleLabel: {
										display: true,
										labelString: 'Tempi (secondi)',
										fontSize: 16,
										fontFamily: "cursive",
										fontColor: '#6d94cd'
									},
									ticks: {
										beginAtZero: true
									},
									gridLines: {
										display: true
									}
								}],
								xAxes: [{
									display: true,
									scaleLabel: {
										display: true,
										labelString: '# Simulazioni',
										fontColor: '#6d94cd',
										fontFamily: "cursive",
										fontSize: 14,
										padding: {
											top: 0
										}
									},
									gridLines: {
										display: false
									}
								}]
							},
							legend: {
								display: true
							},
							responsive: true,
							maintainAspectRatio: false
						}
					}
				})
				.catch(error => {
					this.alertType = "error";
					this.message = "Errore recuperando le statistiche del cliccatore";
				})
				.finally(() => {
					this.isLoadingStats = false;
				});

		},
		customFilter(item, search) {
			if (this.computedDateTime(item["data_ora"]).toLowerCase().indexOf(search.toLowerCase()) > -1) return true;
			return false;
		},
		async espandiNascondiSimulazione(item) {
			await axios
				.post('/sostituisciVariabiliNelleRisposte', {
					// simulazione: JSON.parse(item.simulazione),
					simulazione: item.simulazione,
					idUtente: this.idCliccatore
				})
				.then(response => {
					item.simulazione = response.data;
					this.expandedSim = (this.expandedSim.length > 0 && this.expandedSim[0].data_ora.localeCompare(item.data_ora) == 0) ? [] : [item];
				})
			// this.expandedSim = (this.expandedSim.length > 0 && this.expandedSim[0].data_ora.localeCompare(item.data_ora) == 0) ? [] : [item];
		},
		// mescolaRisposte(risposte){
		//     return risposte.sort(() => Math.random() - 0.5).toString();
		// },
		sostituisciVariabiliNelleRisposte(simulazione, idUtente) {

		}
	},
	computed: {
		// mescolaRisposte(risposte){
		//     return risposte.sort(() => Math.random() - 0.5).toString();
		// }
	}
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');

._pagina_statistiche_personali {
	font-family: 'Montserrat', sans-serif !important;
	font-size: 14px;
	color: #6D94CD;
	font-weight: 400;
	line-height: 1.5;
	padding-top: 20px;
}

._medium {
	font-weight: 500;
}

._semi_bold {
	font-weight: 600;
}

::v-deep .input_seleziona_periodo input {
	color: #6d94cd;
	font-weight: 500;
}

::v-deep .v-input__slot {
	align-items: end;

	& input {
		padding-bottom: 4px;
	}

	& .v-input__icon--clear {
		align-items: end;

		& button {
			color: #bc2025;
			font-size: 20px;
		}

	}
}

::v-deep .statistiche-data-table {
	background-color: #eeeeee;
	color: #434343 !important;

	& .v-data-table-header tr th {
		border-bottom: none !important;
		color: #6d94cd !important;
		// height: 18px;
		// font-size: 15px;
		text-align: center !important;
		// &:not(:nth-child(2)) {
		//   color: #6d94cd;
		// }
		// &:nth-child(2) {
		//   color: #fff;
		//   background-color: #e6901c;
		// }
	}

}

::v-deep .statistiche-data-table ._table_row {
	& td {
		border-bottom: 0 !important;
		font-size: 13px;
		text-align: center;
		height: 40px;

		&.bg_green {
			background-color: #8bba40 !important;
		}

		&.bg_red {
			background-color: #bc2025 !important;
		}
	}

	&._dettagli_simulazione td {
		text-align: left;
	}

}

::v-deep .statistiche-data-table .v-data-footer {
	color: #434343;
	font-weight: 600;
	border-top: none !important;

	& .v-data-footer__select {
		margin-left: 4% !important;
	}
}
</style>